export default "__VITE_ASSET__CeiB1Sb9__"